import React, { useContext, useEffect, useState } from 'react'
import Title from 'client/fragments/listerFragment/components/Title/Title'
import { subscribeAndProcess } from 'client/common/pageBus'
import { isMobile } from 'chemistry'
import CategoryAdvise from './Title/CategoryAdvise'
import ListerBreadcrumbs from './BreadCrumbs/ListerBreadcrumbs'
import { useSelector } from 'react-redux'
import { TranslateContext } from 'client/common/translator'

const MOVE_CRUMB_EVENT = 'MOVE_BACK_CRUMB'

const EmptyHeader = () => {
  return <div style={{ gridArea: 'header' }} />
}
const ListerHeader = ({ isSoftContent }) => {
  const categoryCode = useSelector(state => state.data.categoryCode)
  const collectionId = useSelector(state => state.data.collectionId)
  const refProductCode = useSelector(state => state.data.refProductCode)
  const isCustomPromotion = useSelector(state => state.data.isCustomPromotion)
  const breadcrumbs = useSelector(state => state.data.breadcrumbs)
  const page = useSelector(state => state.data.page)
  const ids = useSelector(state => state.data.ids)
  const title = useSelector(state => state.data.page?.title)
  const paramTitle = useSelector(state => state.data.title)

  const t = useContext(TranslateContext)

  const [isMobileDevice, setIsMobileDevice] = useState(false)
  useEffect(() => {
    subscribeAndProcess('lister-fragment', MOVE_CRUMB_EVENT, () => {
      if (collectionId) {
        const backLink = document.getElementById('collectionBackBtn')
        const container = document.querySelector('.promotion-page main > .mxd-page-section:first-child .mxd-container')
        container.insertBefore(backLink, container.firstChild)
      }
    })
  }, [collectionId])
  useEffect(() => {
    if (isMobile()) {
      setIsMobileDevice(true)
    }
  }, [])

  if (collectionId) {
    if (breadcrumbs)
      return <ListerBreadcrumbs breadcrumbs={breadcrumbs} t={t} target={isMobileDevice ? '_self' : '_blank'} />

    if (!refProductCode || isCustomPromotion) return <EmptyHeader />

    const href = `/p/${refProductCode}`
    return (
      <div className='mxd-content-section mxd-container' style={{ gridArea: 'header' }}>
        <div id='collectionBackBtn' className='mxd-breadcrumbs mxd-breadcrumbs-back'>
          <a href={href} className='mxd-icon mxd-icon-left'>
            {t('lister.breadcrumbs.backToProduct')}
          </a>
        </div>
      </div>
    )
  }

  let pageTitle = title
  if (ids && !paramTitle) return <EmptyHeader />
  if (ids && paramTitle) pageTitle = paramTitle

  return (
    <ListerBreadcrumbs breadcrumbs={breadcrumbs} t={t}>
      <Title title={pageTitle} isSoftContent={isSoftContent} />
      {categoryCode && <CategoryAdvise categoryCode={categoryCode} categoryName={page?.title} />}
    </ListerBreadcrumbs>
  )
}

export default ListerHeader
